import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    const closeModalEvent = new CustomEvent('close-global-modal');
    window.dispatchEvent(closeModalEvent);
  }
}